import { DependencyList, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

export const useOnLocaleSwitch = (callback: () => void, dependencies: DependencyList = []) => {
  const { i18n } = useTranslation()
  const callbackRef = useRef(callback)

  useEffect(() => {
    callbackRef.current = callback
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callback, ...dependencies])

  useEffect(() => {
    callbackRef.current()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.resolvedLanguage, ...dependencies])
}
